import { render, staticRenderFns } from "./PaypalAccounts.vue?vue&type=template&id=af98314a"
import script from "./PaypalAccounts.vue?vue&type=script&lang=js"
export * from "./PaypalAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports